/** Root `<form>` in sheet create/edit flows: flex column, footer pinned below scroll body. */
export const FORM_SHEET_ROOT_FORM_CLASS = "flex min-h-0 flex-1 flex-col";

/** Scrollable form body inside create/edit sheets (citation, DAR, stored vehicle). */
export const FORM_SHEET_FORM_CLASS =
  "flex flex-1 flex-col space-y-6 overflow-y-auto px-4 pb-4 pt-2";

/**
 * Pinned footer at the bottom of sheet forms — sibling of `SheetFormScrollBody`, not inside it.
 * When a compliance gate is deferred, the sheet panel shrinks above `--compliance-sticky-bar-height`.
 */
export const FORM_SHEET_FOOTER_CLASS =
  "shrink-0 border-t border-border/60 bg-background px-4 pb-[max(1rem,var(--app-safe-area-bottom,env(safe-area-inset-bottom,0px)))] pt-3";
